/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PlasmidViewFilterConstants } from './PlasmidViewFilterConstants';
import {
    PlasmidViewFilterConstantsFromJSON,
    PlasmidViewFilterConstantsFromJSONTyped,
    PlasmidViewFilterConstantsToJSON,
} from './PlasmidViewFilterConstants';
import type { StrandConstants } from './StrandConstants';
import {
    StrandConstantsFromJSON,
    StrandConstantsFromJSONTyped,
    StrandConstantsToJSON,
} from './StrandConstants';

/**
 * 
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof Feature
     */
    featureTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    featureTypeLabel?: string;
    /**
     * 
     * @type {PlasmidViewFilterConstants}
     * @memberof Feature
     */
    filter: PlasmidViewFilterConstants;
    /**
     * 
     * @type {number}
     * @memberof Feature
     */
    start: number;
    /**
     * 
     * @type {number}
     * @memberof Feature
     */
    stop: number;
    /**
     * 
     * @type {StrandConstants}
     * @memberof Feature
     */
    strand: StrandConstants;
    /**
     * 
     * @type {boolean}
     * @memberof Feature
     */
    shouldBeTranslated?: boolean;
}

/**
 * Check if a given object implements the Feature interface.
 */
export function instanceOfFeature(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "featureTypeId" in value;
    isInstance = isInstance && "filter" in value;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "stop" in value;
    isInstance = isInstance && "strand" in value;

    return isInstance;
}

export function FeatureFromJSON(json: any): Feature {
    return FeatureFromJSONTyped(json, false);
}

export function FeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): Feature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'featureTypeId': json['featureTypeId'],
        'featureTypeLabel': !exists(json, 'featureTypeLabel') ? undefined : json['featureTypeLabel'],
        'filter': PlasmidViewFilterConstantsFromJSON(json['filter']),
        'start': json['start'],
        'stop': json['stop'],
        'strand': StrandConstantsFromJSON(json['strand']),
        'shouldBeTranslated': !exists(json, 'shouldBeTranslated') ? undefined : json['shouldBeTranslated'],
    };
}

export function FeatureToJSON(value?: Feature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'label': value.label,
        'featureTypeId': value.featureTypeId,
        'featureTypeLabel': value.featureTypeLabel,
        'filter': PlasmidViewFilterConstantsToJSON(value.filter),
        'start': value.start,
        'stop': value.stop,
        'strand': StrandConstantsToJSON(value.strand),
        'shouldBeTranslated': value.shouldBeTranslated,
    };
}

